import { render } from "./WorkHistoryListAlternative.vue?vue&type=template&id=b3f9af5a&ts=true"
import script from "./WorkHistoryListAlternative.vue?vue&type=script&lang=ts"
export * from "./WorkHistoryListAlternative.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__